import { Container, Typography, Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <Container sx={{ py: 4, textAlign: 'center' }}>
      <Box>
        <Typography variant="h1" component="h1" gutterBottom sx={{ mt: 8, fontWeight: 700, color: 'primary.main' }}>
          404
        </Typography>
        <Typography variant="h4" component="h2" gutterBottom>
          Oops! Page Not Found.
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: 'text.secondary', mb: 3 }}>
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained" color="primary" size="large">
          Go to Homepage
        </Button>
      </Box>
    </Container>
  );
};
export default NotFoundPage;
